import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { AuthResponse } from '@/api/v1/auth/login'
import { LOCAL_STORAGE_KEYS } from '@/lib/local-storage-keys'

interface AuthStore {
  accessToken: string | null
  refreshToken: string | null
  expiresIn: number | null
  tokenType: string | null

  setAuth: (auth: AuthResponse) => void
  clearAuth: () => void
  isAuthenticated: () => boolean
}

export const useAuthStore = create<AuthStore>()(
  // @ts-ignore - Known issue with Zustand 5.x and TypeScript strict mode with persist middleware
  persist(
    (set, get) => ({
      accessToken: null,
      refreshToken: null,
      expiresIn: null,
      tokenType: null,

      setAuth: (auth) => {
        set({
          accessToken: auth.accessToken,
          refreshToken: auth.refreshToken,
          expiresIn: auth.expiresIn,
          tokenType: auth.tokenType,
        })
      },

      clearAuth: () => {
        set({
          accessToken: null,
          refreshToken: null,
          expiresIn: null,
          tokenType: null,
        })
      },

      isAuthenticated: () => {
        return !!get().accessToken
      },
    }),
    {
      name: LOCAL_STORAGE_KEYS.AUTH,
    },
  ),
)
